import React, { useEffect, useRef } from "react";
import { Building2, Phone, Mail, ArrowUpRight } from "lucide-react";
import "./ContactPage.css";
import FAQ from "./faq";

const ContactPage = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-visible");
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <div className="contact-page-wrapper">
      <div className="contact-glow"></div>

      <div className="contact-container">
        {/* Header Section */}
        <div className="contact-header">
          <span className="contact-badge">LET'S CONNECT</span>

          <h1 className="contact-title">
            We would love to hear
            <br />
            from you
          </h1>

          <p className="contact-subtitle">
            Have questions or just want to say hi? Fill the form below and we'll
            reach out or directly call at +91 78510 03243
          </p>
        </div>

        {/* Main Card */}
        <div ref={sectionRef} className="contact-card reveal-item">
          {/* Left Column */}
          <div className="contact-info-col">
            <p className="contact-intro-text">
              Connect with us. We value your input.
              <br />
              Together, we can create a better financial
              <br />
              future. Let's start today.
            </p>

            <div className="info-blocks">
              <div className="info-block">
                <div className="info-block-header">
                  <Building2 className="info-icon" size={22} />
                  <span>Head Office</span>
                </div>

                <p>
                  O-33, Second Floor, Amber Tower,
                  <br />
                  Sansar Chandra Road, Jaipur-302001
                </p>
              </div>

              <div className="info-block">
                <div className="info-block-header">
                  <Phone className="info-icon" size={22} />
                  <span>Phone</span>
                </div>

                <p>+91 78510 03243</p>
              </div>

              <div className="info-block">
                <div className="info-block-header">
                  <Mail className="info-icon" size={22} />
                  <span>Email</span>
                </div>

                <p>nikhil.gupta@poonjimitra.com</p>
              </div>
            </div>
          </div>

          {/* Right Column (Form) */}
          <div className="contact-form-col">
            <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
              <input
                type="text"
                placeholder="Enter Your Name"
                className="form-input"
                required
              />

              <input
                type="email"
                placeholder="Enter Your Email"
                className="form-input"
                required
              />

              <textarea
                placeholder="Message"
                className="form-textarea"
                required
              ></textarea>

              <button type="submit" className="submit-btn">
                Submit <ArrowUpRight size={18} />
              </button>

              <p className="form-footer-text">
                We will reach out to you within about 24 hours on work days
              </p>
            </form>
          </div>
        </div>
      </div>

      <FAQ />
    </div>
  );
};

export default ContactPage;
